import { CircularProgress, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const LoginSSOSystem = ({
    provider,
    errorMessage
}) => {
    const { t } = useTranslation()
    
    return (
        <div className="form-register-container">
            <div className="form-register-body" style={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
            </div>
            <Typography textAlign={'center'}>
                {t(`auth.${provider}`)}
            </Typography>
            <Typography textAlign={'center'}>
                {t(errorMessage)}
            </Typography>
        </div>
    )
}

export default LoginSSOSystem